// @flow

import { connect } from 'react-redux';
import { updateMyLineup } from '../../actions/myTeamsActions';
import LineUpBuilder from '../../components/challenge/LineUpBuilder';

function mapStateToProps() {
  return {
    isChallengeBuilder: true
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onSubmit(...args) {
      dispatch(updateMyLineup(...args));
    }
  };
}

function mergeProps(stateProps, { onSubmit, ...restDispatchProps }, ownProps) {
  return {
    ...stateProps,
    ...restDispatchProps,
    ...ownProps,
    onSubmit() {
      onSubmit(ownProps.lineupId, {
        name: ownProps.challengeName,
        slate_id: ownProps.slateId,
        total_fee: ownProps.entryFee,
        quantity: ownProps.numChallengesToCreate
      });
    }
  };
}

const EditLineUpBuilder = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(LineUpBuilder);

export default EditLineUpBuilder;
